import { env } from '@/config/environment';

/**
 * Resolves a cover_image field value to a full public URL.
 *
 * DRF ImageField with use_url=False returns a bare relative path
 * (e.g. "covers/book.jpg"). This prepends /media/ and the API origin
 * so the browser can reach the file through nginx.
 */
export const resolveCoverImageUrl = (url?: string | null): string | null => {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;

  let path = url.startsWith('/') ? url : `/${url}`;
  if (!path.startsWith('/media/') && !path.startsWith('/static/')) {
    path = `/media${path}`;
  }

  if (typeof window === 'undefined') return path;
  const apiOrigin = new URL(env.apiBaseUrl, window.location.origin).origin;
  return `${apiOrigin}${path}`;
};
